import Vue from 'vue'
import App from './App.vue'
import router from './router';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueAuth from '@websanova/vue-auth';
import Multiselect from 'vue-multiselect';
import auth from './auth.js';
import { BootstrapVue } from 'bootstrap-vue';
import Vuex from 'vuex';
import VueSweetalert2 from 'vue-sweetalert2';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBed as falBed, faBath as falBath, faHomeAlt as falHomeAlt, faQuestionCircle as falQuestionCircle, faExclamationCircle as falExclamationCircle, faGlobe as falGlobe, faSignOut as falSignOut, faCarGarage as falCarGarage, faWarehouseAlt as falWarehouseAlt, faBuilding as falBuilding, faSeedling as falSeedling, faMale as falMale, faGamepad as falGamepad, faMoneyCheckAlt as falMoneyCheckAlt, faFilePdf as falFilePdf, faBookUser as falBookUser, faFileInvoiceDollar as falFileInvoiceDollar, faFileAlt as falFileAlt, faFileContract as falFileContract, faFileSignature as falFileSignature, faLeaf as falLeaf, faDumbbell as falDumbbell, faDoorClosed as falDoorClosed, faChartLine as falChartLine, faCamera as falCamera, faImages as falImages, faPlus as falPlus, faGarageCar as falGarageCar, faFileSearch as falFileSearch, faBars as falBars, faCaretRight as falCaretRight } from '@fortawesome/pro-light-svg-icons';
import { faUserSecret as fasUserSecret, faCircle as fasCircle, faCreditCard, faDownload as fasDownload } from "@fortawesome/free-solid-svg-icons";
import { faFacebookF, faInstagram, faWhatsapp, faCcMastercard, faCcVisa, faCcDinersClub, faCcAmex } from '@fortawesome/free-brands-svg-icons'
import {FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText} from '@fortawesome/vue-fontawesome';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';
import 'bootstrap/dist/css/bootstrap.css';
import 'vue-search-select/dist/VueSearchSelect.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import JwPagination from 'jw-vue-pagination';
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.config.productionTip = false

const instance = axios.create({
	baseURL: process.env.VUE_APP_API_URL,
	params: {}
});
library.add(fasDownload, fasUserSecret, fasCircle, faFacebookF, faWhatsapp, faInstagram, falBed, falBath, falHomeAlt, falQuestionCircle, falExclamationCircle, falGlobe, falSignOut, falCarGarage, falWarehouseAlt, falBuilding, falSeedling, falMale, falGamepad, falMoneyCheckAlt, falFilePdf, falBookUser, falFileInvoiceDollar, falFileAlt, falFileContract, falFileSignature, falLeaf, falDumbbell, falDoorClosed, falChartLine, falGarageCar, falCamera, falImages, falPlus, falFileSearch, falBars, falCaretRight, faCcMastercard, faCcVisa, faCcDinersClub, faCcAmex, faCreditCard );
Vue.use(VueAxios, instance);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.component('font-awesome-layers-text', FontAwesomeLayersText);
Vue.component('multiselect', Multiselect);
Vue.use(BootstrapVue);
Vue.use(VueSweetalert2);

Vue.component('jw-pagination', JwPagination);
Vue.router = router;
App.router = Vue.router;
Vue.use(VueMoment,{moment});
Vue.use(VueAuth, auth);
Vue.use(Vuex)
Vue.use(VueSweetalert2);

const store = new Vuex.Store({
	state: {
		customer: process.env.VUE_APP_CUSTOMER,
		customer_name: process.env.VUE_APP_CUSTOMER_NAME,
		customer_domain: process.env.VUE_APP_CUSTOMER_DOMAIN,
		customer_id: process.env.VUE_APP_CUSTOMER_ID,
		customer_link: process.env.VUE_APP_CUSTOMER_LINK,
		customer_backend: process.env.VUE_APP_CUSTOMER_BACKEND,
		customer_site: process.env.VUE_APP_CUSTOMER_SITE,
		customer_color: '#c50f2A',
		Apartments: [],
		observations:[],
		loading: false,
		projects: null,
		complementaries: null,
		oportunities: null,
		notices: null,
		slides: null,
		header: null,
		uf: null,
		cards: [],
	},
	mutations:{
		setApartments: (state, apr) => {
			if(apr){
				state.apartments = apr;
			}
		},
		removeApartments: (state) => {
			state.apartments = []
		},
		addObservation(state, observation) {
			state.observations.push(observation)
		},
		deleteObservation(state, position) {
			state.observations.splice(position, 1);
		},
		setRequest: (state, reception) => {
			state.reception = reception;
		},
		setCards(state){
			instance.get("payments/oneclick").then(result => {
				state.cards = result.data;
			});
		},
	},
	actions: {
		setApartments(context){
			context.commit('setApartments');
		},
		setHeader(context, page){
			context.commit('setHeader', page);
		},
		setCards(context){
			context.commit('setCards');
		},

	},
	getters: {
		getApartmentById: (state) => (id) => {
			let apartment = state.apartments.find(apartment => apartment.asset_id === id);
			if(apartment){
				state.phone = apartment.project_phone;
			}
			return apartment;
		},
		getProjectByMoby: (state) => (project_id) => {
			return (state.projects ? state.projects.find(project => project.project_id == project_id) : null );
		},
		getProjectByLink: (state) => (project_id) => {
			return (state.projects ? state.projects.find(project => project.link == project_id) : null );
		},
		getSlides(state){
			return state.slides;
		},
		getApartments(state){
			return state.apartments;
		},
		getComplementaries(state){
			return state.complementaries;
		},
		getCards(state){
			return state.cards;
		},
	}
});

Vue.filter('numberFormat', function(value){
	let roundedValue = Math.round(value*100)/100
	let number = roundedValue.toString().split(".")
	let numberFormated = number.length > 1 ?  number[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".")+","+number[1] : number[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".")
	return numberFormated ? numberFormated : 0;
});

new Vue({
	components: {},
	router,
	store,
    validations: {},
	axios,
	render: h => h(App)
}).$mount('#app')
